import { Injectable, NgZone } from '@angular/core';
import { fromEvent, merge, Subscription } from 'rxjs';
import { throttleTime } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class UserActivityService {
    private activitySubscription: Subscription | null = null;
    private activityCallback: (() => void) | null = null;
    private isListening: boolean = false;

    constructor(private ngZone: NgZone) { }

    public startListening(callback: () => void): void {

        console.log('Start Activity')
        if (this.isListening) {
            return;
        }

        this.activityCallback = callback;
        this.isListening = true;

        // Run outside Angular zone for better performance
        this.ngZone.runOutsideAngular(() => {
            // Define activity events to monitor
            const activityEvents = [
                fromEvent(document, 'mousemove'),
                fromEvent(document, 'mousedown'),
                fromEvent(document, 'keypress'),
                fromEvent(document, 'keydown'),
                fromEvent(document, 'click'),
                fromEvent(document, 'scroll'),
                fromEvent(document, 'touchstart'),
                fromEvent(document, 'touchmove')
            ];

            // Merge all events and throttle to prevent excessive calls
            // Throttle to once every 1 second to optimize performance
            this.activitySubscription = merge(...activityEvents)
                .pipe(throttleTime(1000))
                .subscribe(() => {
                    // Run callback inside Angular zone
                    this.ngZone.run(() => {
                        if (this.activityCallback) {
                            this.activityCallback();
                        }
                    });
                });
        });
    }

    public stopListening(): void {
        if (this.activitySubscription) {
            this.activitySubscription.unsubscribe();
            this.activitySubscription = null;
        }

        this.activityCallback = null;
        this.isListening = false;
    }

    public isCurrentlyListening(): boolean {
        return this.isListening;
    }
}
